module.exports = __webpack_public_path__ + "static/barbershop-in-thailand-8791f5128e84171e9aa3543f533db26b.ttf";